<div class="app-container app-theme-white body-tabs-shadow fixed-sidebar fixed-header" [class.closed-sidebar]="!isMobile && isSidebarClosed" [class.sidebar-mobile-open]="isMobile && isSidebarClosed">
    <app-default-header (toggleSidebar)="toggleSidebar()"></app-default-header> 
   <div class="main app-main">
      <app-default-sidebar></app-default-sidebar>
         <div class="app-main__outer">
            <router-outlet></router-outlet>
            <!-- <app-default-footer></app-default-footer> -->
         </div>
    </div>
</div>


